import { ProductExtrasForm } from '@partials/forms/product-detail/product-extras'

export type IProductExtrasTab = Parameters<typeof ProductExtrasForm>[0]

export const ProductExtrasTab = ({ onError }: IProductExtrasTab) => {
  return <ProductExtrasForm onError={onError} />
}
